import CheckIcon from '@material-ui/icons/Check';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';

import { ReactComponent as HashtagIcon } from 'pages/Teachers/shared/AssignmentDialog/assets/hashtag.svg';
import {
  AssignmentDepthOptions,
  AssignmentTaskValueTypes
} from 'utils/constants';

export const EMPTY_TASK = {
  name: '',
  value_type: AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR,
  depth: AssignmentDepthOptions.TASK,
  description: '',
  children: [],
  standards: []
};

export const FIRST_PAGE = {
  ...EMPTY_TASK,
  name: 'Page 1'
};

export const EMPTY_CRITERIA = {
  name: '',
  value_type: AssignmentTaskValueTypes.CHECKBOX,
  depth: AssignmentDepthOptions.CRITERIA,
  description: ''
};

export const VALUES_OPTIONS = [
  // TODO: Add this after we revise correct/incorrect default value for assignment level 1 objectives
  // {
  //   key: 'checkbox',
  //   Icon: CheckBoxOutlinedIcon,
  //   text: 'Correct/Incorrect'
  // },
  {
    key: 'check_grade',
    Icon: CheckIcon,
    text: 'Check grade'
  },
  {
    key: 'rubric_zero_four',
    Icon: FormatListNumberedIcon,
    text: '0-4 Rubric'
  },
  {
    key: 'rubric_zero_three',
    Icon: FormatListNumberedIcon,
    text: '0-3 Rubric'
  },
  {
    key: 'rubric_zero_two',
    Icon: FormatListNumberedIcon,
    text: '0-2 Rubric'
  },
  {
    key: 'rubric',
    Icon: FormatListNumberedIcon,
    text: '1-4 Rubric'
  },
  {
    key: 'number',
    Icon: HashtagIcon,
    text: 'Number'
  }
  // TODO: Add this after we revise the student page
  // {
  //   key: 'text',
  //   Icon: TextFormatRoundedIcon,
  //   text: 'Text'
  // }
];

export const errorOptions = [
  {
    value: 'Overall response rating is incorrect',
    label: 'Overall response rating is incorrect'
  },
  {
    value: 'Strategy selected is incorrect',
    label: 'Strategy selected is incorrect'
  },
  { value: 'Missing strategy', label: 'Missing strategy' },
  { value: 'Something else', label: 'Something else' }
];
